import {
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Text,
} from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { useCallback } from 'react';

import { createAppModal } from 'utils/modal';
import { useCopilotTrial } from 'utils/useCopilotTrial';

import styles from './copilotTrialOutroModal.module.scss';

export const CopilotTrialOutroModal = createAppModal(
  { type: 'app:copilotTrialOutro' },
  ({ isOpen, hide }): JSX.Element => {
    const {
      setDismissedOutroModal,
      setRequestForContactSent,
      openRequestFormContactForm,
    } = useCopilotTrial();
    const handleClose = (): void => {
      setDismissedOutroModal();
      hide?.();
    };

    const requestCopilotModal = useCallback(async () => {
      ampli.agentCopilotTrialRequestContactClicked();
      hide?.();
      const { isSent } = await openRequestFormContactForm();
      if (isSent) {
        setRequestForContactSent();
      }
    }, [hide, openRequestFormContactForm, setRequestForContactSent]);

    return (
      <Modal isOpen={isOpen} onClose={handleClose} className={styles.modal}>
        <ModalHead
          title="Your Agent Co-pilot Trial has ended"
          onClose={handleClose}
        />

        <ModalBody>
          <Text.Paragraph>
            The trial has concluded, and we&apos;re thrilled to hear how Agent
            Co-pilot positively impacted your team!
          </Text.Paragraph>

          <br />

          <Text.Paragraph>
            Eager to continue unlocking the potential of Agent Co-pilot? Reach
            out for our contact, and let&apos;s explore all the incredible
            opportunities it brings!
          </Text.Paragraph>
        </ModalBody>

        <ModalFoot
          confirmName="Request contact"
          confirmOnClick={requestCopilotModal}
        />
      </Modal>
    );
  },
);
